import { setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

export class CheckboxValueSetter {

  setValue(values) {

    const optionViews = this.input.views;
    const optionViewsLength = optionViews.length;

    for (let index = 0; index < optionViewsLength; index++) {

      const optionView = optionViews[index];

      setAttr(optionView.input, {
        checked: values[index]
      });

    }

    return values;

  }

  reset() {

    const optionViews = this.input.views;

    for (let optionView of optionViews) {

      optionView.input.checked = false;

    }

  }

}

export class CheckboxValueGetter {

  getValue() {

    const optionViews = this.input.views;

    const values = [];

    for (let optionView of optionViews) {

      if (optionView.input.checked === false) {
        continue;
      }

      values.push(optionView.label.textContent);

    }

    return values;

  }

}

export class InputValueSetter {

  setValue(value) {

    this.input.value = value;

  }

  reset() {

    this.input.value = '';

  }

}

export class InputValueGetter {

  getValue() {
    return this.input.value;
  }

}

export class SelectInputValueSetter {

  setValue(value) {

    this.input.el.value = value;

  }

  reset() {

    this.input.el.value = '';

  }

}

export class SelectInputValueGetter {

  getValue() {
    return this.input.el.value;
  }

}